import type { DiscountValidationResult } from '@printtat/shared';
import { apiJson } from '@/lib/apiFetch';

export const discountApi = {
  async validate(code: string): Promise<DiscountValidationResult> {
    return apiJson<DiscountValidationResult>('/discounts/validate', {
      method: 'POST',
      body: { code },
    });
  },
};
